import * as api from '../api/labels';
import { asyncAction } from './common';

export const fetchLabels = () => asyncAction('FETCH_LABELS', api.fetchLabels());

export const updateLabel = (label) => asyncAction('UPDATE_LABEL', api.updateLabel(label));

export const createLabel = (label) => asyncAction('CREATE_LABEL', api.createLabel(label));

export const updateLabelFromState = (label) =>
  asyncAction('UPDATE_LABEL', api.updateLabelFromState(label));

export const saveLabel = (label) => (label.id ? updateLabelFromState(label) : createLabel(label));

export const deleteLabel = (id) => asyncAction('DELETE_LABEL', api.deleteLabel(id));

export const addNewLabel = (duration) => ({
  type: 'ADD_NEW_LABEL',
  duration,
});

export const selectLabel = (label) => ({
  type: 'SELECT_LABEL',
  label,
});

export const inputTitle = (title) => ({
  type: 'INPUT_LABEL_TITLE',
  title,
});

export const inputDescription = (description) => ({
  type: 'INPUT_LABEL_DESCRIPTION',
  description,
});

export const setDuration = (duration) => ({
  type: 'SET_LABEL_DURATION',
  duration,
});

export const closeLabelsModal = () => ({
  type: 'CLOSE_LABELS_MODAL',
});

export const setLabelsCurrentDate = (date) => ({
  type: 'UPDATE_LABELS_CURRENT_DATE',
  date,
});
